enum SubscriptionMode {
    MANUAL = 'manual',
    USER = 'user',
    SEATS = 'seats',
    WORKSPACE = 'workspace',
}

export default SubscriptionMode;
